module.exports = __webpack_public_path__ + "img/status_4.31a323ce.png";